/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './styles.module.scss';
import { formatDate, formatPrice, showData } from 'utils/common';
import { useTranslation } from 'react-i18next';
import { Skeleton, SpaceProps } from 'antd-mobile';
import { FaAngleRight } from 'react-icons/fa6';

type Props = {
  roomName?: string;
  availableDate?: string;
  price?: number;
  isSkeleton?: boolean;
};

function AvailableRoomMiniCard({
  roomName,
  availableDate,
  isSkeleton = false,
  price,
  ...nest
}: Props & SpaceProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.contractCard} {...nest}>
      <div className={styles.mainInfo}>
        {isSkeleton ? (
          <Skeleton
            animated
            style={{
              width: '100%',
              height: 'var(--font-lg)',
            }}
          />
        ) : (
          <p className="font-bold font-lg color-grey-01">
            {t('title.room')}: <span className="color-black">{showData(roomName)}</span>
          </p>
        )}
        <div className={styles.blockInfo}>
          {isSkeleton ? (
            <Skeleton
              animated
              style={{
                width: '200px',
                height: '22px',
              }}
            />
          ) : (
            <>
              {availableDate ? (
                <p className={styles.comingRoom}>
                  {showData(availableDate && formatDate(availableDate))}
                </p>
              ) : (
                <p className={styles.emptyRoom}>{t('title.empty-room')}</p>
              )}
              <p className={styles.price}>{showData(price && formatPrice(price, true))}</p>
            </>
          )}
        </div>
      </div>
      {!isSkeleton && (
        <FaAngleRight className={styles.icon} fontSize={'18px'} color="var(--black)" />
      )}
    </div>
  );
}

export default React.memo(AvailableRoomMiniCard);
